const config = {
  API_URL: "https://api.examhub.lk",
  IDEA_MART: "https://api.sysfonix.com",
};

export default config;
